import { memo } from 'react';
import type { WidgetPropsByType } from '@trinity/chat';
import { SegmentationDashboardWidget } from '@trinity/chat';
import { ChartVisualization } from '../Project.QuantAnalysis/components/ChartVisualization';

// Widget-specific wrapper that always hides the legend
// TODO: once the new chartvisualization is cutover, uncomment the hideLegend and useCompactLegend
const ChartVisualizationWidget = memo((props: WidgetPropsByType[SegmentationDashboardWidget.ChartVisualization]) => (
  // <ChartVisualization
  //   {...props}
  //   hideLegend={false}
  //   useCompactLegend={true} />
  <ChartVisualization
    {...props}
  />
));

// Maps type of widget to its corresponding component
// All widget components must be registered here to be rendered in a template
export const WIDGET_COMPONENT_MAP: {
  [K in SegmentationDashboardWidget]: React.ComponentType<WidgetPropsByType[K]>;
} = {
  [SegmentationDashboardWidget.ChartVisualization]: ChartVisualizationWidget,
};
